import { Component, OnInit, Input } from '@angular/core';
import { Router, Event, NavigationStart, NavigationEnd } from '@angular/router';

import { CMSContentService } from '../essentials/cms/content/cms-content.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'fcp-floating-links',
  templateUrl: './floating-links.component.html',
  styleUrls: ['./floating-links.component.scss']
})
export class FloatingLinksComponent implements OnInit {
  public floating;
  public survey;
  public showHelpdesk = true;
  public surveyVisible = false;
  public interval;
  public timeUsing = 0;

  constructor(
    private cmsContentService: CMSContentService,
    private cookieService: CookieService,
    private router: Router
  ) {
    setInterval(() => {
      this.countMinutes();
    }, 60000);

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        if (event.url === '/' || event.url.indexOf('home') >= 0) {
          this.showHelpdesk = true;
        } else {
          this.showHelpdesk = false;
        }
        this.countNavigation();
      }
    });

  }

  ngOnInit() {
    this.cmsContentService.getFloating().subscribe(response => {
      this.floating = response;
    })
  }

  showSurvey(data) {
    const nav = +window.localStorage.getItem('nav');
    const min = +window.localStorage.getItem('min');
    const cookie = this.cookieService.get('survey');

    if (cookie !== data.slug) {
      if (nav > data.minPages || min > data.minMinutes) {
        this.surveyVisible = true;
        return true;
      }
    }
    return false;
  }

  countNavigation() {
    const nav = +window.localStorage.getItem('nav');
    if (nav) {
      const newCount = nav + 1;
      window.localStorage.setItem('nav', newCount as unknown as string);
    } else {
      window.localStorage.setItem('nav', '1');
    }
  }

  countMinutes() {
    const minutes = +window.localStorage.getItem('minutes');
    if (minutes) {
      const newCount = minutes + 1;
      window.localStorage.setItem('minutes', newCount as unknown as string);
    } else {
      window.localStorage.setItem('minutes', '1');
    }
  }

  sendSurvey(survey) {
    this.cmsContentService.postSurvey(survey);
  }
}
